import '../css/module_podcast.scss';

import Collapse from 'bootstrap/js/dist/collapse'
import Modal from 'bootstrap/js/dist/modal'
import Dropdown from 'bootstrap/js/dist/dropdown'

import {doLast} from './module_last';
import { initFirebaseApp } from './module_firebase';
import { manageLogin, openSignInModal } from './module_auth_helper';

import {configPlayerCard} from './module_player-card';
import {attachTryPremiumSubscribe, funnelUpdateWhenAvailable} from './module_common';
import {attachReadMoreClick} from './module_readmore';

import {attachToggleActionButton} from './module_toggle-button';

import {handleCardPlayer} from './module_player-card';
window.handleCardPlayer = handleCardPlayer

import {   
    podcastFollow,
    podcastUnfollow,
} from './module_api_call';

import './module_common_actions';

import {
    attachCtaActions,
} from './module_actions';

import { initNavbar } from './module_header';

function managePodcastFollow(pid, action){
    if (action === 'remove'){
        return podcastUnfollow(pid)
    }
    return podcastFollow(pid)
}

function attachEpisodeLockClick(){
    $(".episode-lock-ref").click(function(e){
        openSignInModal()
    })
}

$(function () {
    initFirebaseApp()
    manageLogin()

    attachTryPremiumSubscribe()
    
    doLast()

    initNavbar()
    configPlayerCard()
    attachReadMoreClick()

    attachCtaActions()

    attachEpisodeLockClick()

    // attachToggleActionButton(managePodcastFollow)
    if (!isPageReloadedAfterLogin) funnelUpdateWhenAvailable('podcast_viewed');
});